import { createSelectorCreator } from 'reselect';
import { memoize } from 'lodash';

const hashFn = (...args) => JSON.stringify(args);
export default createSelectorCreator(memoize, hashFn);
